export const BUILD_VERSION = '363dfb2ad08ff468970a7d3b0a12c4a352bbd11c';
